import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import Header from "../../components/header/Header";
import { configAction } from "../../store/config/slice";
import { GameStep } from "../../types/config";
import style from "./banibon.module.css";
import Card from "../../components/DiscountCard/Card";
import Placeholder from "../../components/placeHolder/PlaceHolder";
import { placeHolder } from "../../types/common";
// import FooterCo from "../../components/footer/FooterCo";
import { getBanibons } from "../../store/banibons/action";
import BanicoinCard from "../../components/DiscountCard/BanicoinCard/BanicoinCard";
import PS5Badge from "../../components/PS5Badge/PS5Badge";
import { configBrandsType } from "../../types/brands";
import BrandItems from "../../components/brands/BrandsItems/BrandItems";
import ExpireCard from "../../components/DiscountCard/ExpireCard/ExpireCard";
// import Brands from "../../UI/brands/Brands";
const BanibonPage = () => {
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => state.config.token);
  const coupons = useAppSelector((state) => state.banibons.banibon);
  const [activeTab, setActiveTab] = useState<"expire" | "active">("active");
  useEffect(() => {
    dispatch(getBanibons(token!));
    window.addEventListener("popstate", () => {
      dispatch(configAction.setGameStep(GameStep.HOME));
    });
  }, []);
  const handleBack = function () {
    window.history.pushState({}, "", "?");
    dispatch(configAction.setGameStep(GameStep.HOME));
  };
  const expireBanibons = coupons.data?.data.coupons.filter(
    (item) => item.isExpire === true
  );
  const activeBanibons = coupons.data?.data.coupons.filter(
    (item) => item.isExpire === false
  );
  const brands = useAppSelector(
    (state) => state.brands.brands.data?.data.components
  );
  const banibonBrands = brands?.find((item) => {
    const config = JSON.parse(item.config!) as configBrandsType;
    return config.type === "banibon";
  });

  return (
    <div className={style.banibon}>
      <div className={style.wrapper}>
        <Header title="لیست جوایز من" onBack={handleBack} />
        <div className={style.inner}>
          <div className={style.tabs}>
            <button
              className={`${style.tab} ${
                activeTab === "active" ? style["tab-active"] : ""
              }`}
              onClick={() => {
                setActiveTab("active");
              }}
            >
              جوایز فعال
            </button>
            <button
              className={`${style.tab} ${
                activeTab === "expire" ? style["tab-active"] : ""
              }`}
              onClick={() => {
                setActiveTab("expire");
              }}
            >
              جوایز منقضی‌شده
            </button>
          </div>
          {activeTab === "active" && (
            <div className={style.items}>
              <PS5Badge
                badgeClassname={style.normalBadge}
                innerClassname={style.bagdeInnerNoraml}
                badgeTitleClassName={style.bagdeTitle}
                text="کد تخفیفی که برنده شدی + تخفیف‌های روی سایت"
              />
              <div className={style.itemsInner}>
                {!coupons.loading ? (
                  !!activeBanibons?.length ? (
                    activeBanibons!.map((coupon) => {
                      if (coupon.type === "banicoin") {
                        return (
                          <BanicoinCard
                            {...coupon!}
                            className={style.banicoinCard}
                          />
                        );
                      } else {
                        return (
                          <Card {...coupon!} className={style.normalCard} />
                        );
                      }
                    })
                  ) : (
                    <div className={style.empty}>
                      <div className={style["empty-top"]}>
                        <span className={style["empty-title"]}>
                          هنوز جایزه‌ای نبردی..
                        </span>
                        <span className={style["empty-desc"]}>
                          گردونه رو بچرخون، کلی جایزه در انتظارته!
                        </span>
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/image/empty-banibon.png?v1`}
                          alt=""
                          className={style["empty-hero"]}
                        />
                      </div>
                    </div>
                  )
                ) : (
                  <Placeholder
                    type={placeHolder.CARD}
                    number={12}
                    className={style.placeholder}
                  />
                )}
              </div>
              
            </div>
          )}
          {activeTab === "expire" && (
            <div className={style.items}>
              <div className={style.itemsInner}>
                {!coupons.loading ? (
                  !!expireBanibons?.length ? (
                    expireBanibons!.map((coupon) => (
                      <ExpireCard {...coupon!} small />
                    ))
                  ) : (
                    <div className={style.empty}>
                      <div className={style["empty-top"]}>
                        <span className={style["empty-title"]}>
                          جایزه منقضی شده‌ای نداری..
                        </span>
                        <span className={style["empty-desc"]}>
                          جوایزی که بردی هنوز قابل استفاده هستن!
                        </span>
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/image/empty-banibon.png?v1`}
                          alt=""
                          className={style["empty-hero"]}
                        />
                      </div>
                    </div>
                  )
                ) : (
                  <Placeholder
                    type={placeHolder.CARD}
                    number={12}
                    className={style.placeholder}
                  />
                )}
              </div>
            </div>
          )}
          {/* <Brands title="برند های پیشنهادی:"  /> */}
        </div>
        <div>
          <BrandItems
            title="برندهای پیشنهادی"
            brands={banibonBrands?.attributes?.src_sets.value!}
            isLink
          />
        </div>
      </div>
      {/* <FooterCo className="desktop" /> */}
    </div>
  );
};

export default BanibonPage;
